import header from "src/components/header/header";
import footer from "src/components/footer/footer";
import frontpage from "src/templates/frontpage";
import index_html from "src/templates/index";
import timeline from "src/templates/timeline";
import libary from "src/templates/libary";
import search from "src/templates/search";
import article from "src/templates/article";
import other from "src/templates/other";
import { articlesExtend, getDynamicContent, findsite } from "src/scripts/mixin";

export default () => {


    const categoriesUrl = window.apiUrl + "/api/PublicContentApi/menucategory/" + config.clientId;
    const settingsPage = window.apiUrl + "/api/PublicContentApi/find/e5d66f5c-e3a8-4b2a-93f7-4aed792025cb";

    window.highlightid = "58f370f9-751f-4d03-852c-5a2f9bcef183";

    const initialPromise = [
        new Promise((resolve, reject) => {
            fetch(categoriesUrl).then(response => response.json()).then(data => {
                if (data) {
                    resolve(data);
                }
            })
        }),
        new Promise((resolve, reject) => {
            fetch(settingsPage).then(response => response.json()).then(data => {
                if (data) {
                    data = articlesExtend(data);
                    resolve(data);
                }
            })
        })
    ];

    Promise.all(initialPromise).then(elm => {
        window.catergories = elm[0];
        window.settings = elm[1]

        // define mainHtml
        let html = index_html();
        let container = document.getElementById("page");
        container.innerHTML = html;

        let url = getPageUrl();
        window.site = url.template;
        window.page = url.contentid;

        if (window.site === "frontpage") {
            const frontpageid = getDynamicContent("90da60c3-7713-40dc-86da-389827ee914f", window.settings.metaParsed.currentDynamiskMalContent) // get frontpage id
            // console.log(frontpageid, window.settings.metaParsed.currentDynamiskMalContent);
            frontpage(frontpageid);
        }
        else {
            // set coloring 
            if (window.site !== "frontpage") {
                // console.log("ok before")
                const siteinfo = findsite();
                // console.log("siteinfo",siteinfo);

                if (siteinfo.categoryId === "e94d7a64-2cc1-459c-8e9a-a912e8691615") {
                    document.querySelector("body").classList.add("timeline");

                    if (window.site && !window.page) {
                        timeline();
                    }
                    else {
                        article();
                    }
                }
                else if (siteinfo.categoryId === "d346034b-7477-48da-a519-445aaef9bcd9") {
                    document.querySelector("body").classList.add("libary");

                    if (window.site && !window.page) {
                        libary();
                    }
                    else if(window.site && window.page.match("sok")){
                        search();
                    }
                    else {
                        article();
                    }
                }
                if (siteinfo.categoryId === "96e6f676-9ab6-41d5-a0da-644e7afd4357") {
                    document.querySelector("body").classList.add("other");

                    if (window.site && window.page) {
                        other();
                    }
                }
                
            }
        }
        /// Always set Header
        header(window.catergories);
        footer(window.settings);
    });
}
